import AlertModal from 'components/Modal/AlertModal';
import ConfirmModal from 'components/Modal/ConfirmModal';
import DownloadsModal from 'components/Modal/DownloadsModal';
import DsShowcaseModal from 'components/Modal/DsShowcaseModal';
import FramesAiModal from 'components/Modal/Export/FramesAiModal';
import DsAiModal from 'components/Modal/Export/DsAiModal';
import FramesAssetsModal from 'components/Modal/Export/FramesAssetsModal';
import FramesCodeModal from 'components/Modal/Export/FramesCodeModal';
import PromptModal from 'components/Modal/PromptModal';
import SettingsModal from 'components/Modal/SettingsModal';
import PlanPricingModal from 'components/Modal/PlanPricingModal';
import { shallowEqual, useSelector } from 'react-redux';
import store from 'redux/store';
import {
	hideDownloadsModal,
	hideExportFramesAiModal,
	hideExportDsAiModal,
	hideExportFramesAssetsModal,
	hideExportFramesCodeModal,
} from 'redux/mode/actions';
import { RootReducer, selectIsLoadingAnything } from 'redux/reducers';

const ModalManager = () => {
	const {
		globalPromptModalOptions,
		globalConfirmModalOptions,
		globalAlertModalOptions,
		planPricingModalVisible,
		dsShowcaseModal,
		settingsModalVisible,
		downloadsModalVisible,
		exportFramesAssetsModal,
		exportFramesCodeModal,
		exportFramesAiModal,
		exportDsAiModal,
	} = useSelector((r: RootReducer) => {
		return {
			loading: selectIsLoadingAnything(r),
			sceneLoadError: r.db.sceneLoadError,
			globalPromptModalOptions: r.mode.promptModal,
			globalConfirmModalOptions: r.mode.confirmModal,
			globalAlertModalOptions: r.mode.alertModal,
			planPricingModalVisible: r.mode.planPricingModalVisible,
			dsShowcaseModal: r.mode.dsShowcaseModal,
			settingsModalVisible: r.mode.settingsModalVisible,
			downloadsModalVisible: r.mode.downloadsModalVisible,
			exportFramesAssetsModal: r.mode.exportFramesAssetsModal,
			exportFramesCodeModal: r.mode.exportFramesCodeModal,
			exportFramesAiModal: r.mode.exportFramesAiModal,
			exportDsAiModal: r.mode.exportDsAiModal,
		};
	}, shallowEqual);

	return (
		<>
			{globalPromptModalOptions && <PromptModal options={globalPromptModalOptions} />}
			{globalConfirmModalOptions && <ConfirmModal options={globalConfirmModalOptions} />}
			{globalAlertModalOptions && <AlertModal options={globalAlertModalOptions} />}
			{planPricingModalVisible && <PlanPricingModal />}
			{dsShowcaseModal && <DsShowcaseModal />}
			{settingsModalVisible && <SettingsModal />}
			{downloadsModalVisible && (
				<DownloadsModal onClose={() => store.dispatch(hideDownloadsModal())} />
			)}
			{exportFramesAssetsModal.visible && (
				<FramesAssetsModal
					fixedFrameIds={exportFramesAssetsModal.fixedFrameIds}
					onClose={() => store.dispatch(hideExportFramesAssetsModal())}
				/>
			)}
			{exportFramesCodeModal.visible && (
				<FramesCodeModal
					fixedFrameIds={exportFramesCodeModal.fixedFrameIds}
					onClose={() => store.dispatch(hideExportFramesCodeModal())}
				/>
			)}
			{exportFramesAiModal.visible && (
				<FramesAiModal
					fixedFrameIds={exportFramesAiModal.fixedFrameIds}
					onClose={() => store.dispatch(hideExportFramesAiModal())}
				/>
			)}

			{exportDsAiModal.visible && (
				<DsAiModal
					initialPreset={exportDsAiModal.initialPreset}
					initialComponentNames={exportDsAiModal.initialComponentNames}
					initialCustomPrompt={exportDsAiModal.initialCustomPrompt}
					onClose={() => store.dispatch(hideExportDsAiModal())}
				/>
			)}
		</>
	);
};

export default ModalManager;
